// TASKS
export const TASK_STATUSES = ['To Do', 'In Progress', 'Needs Review', 'Done'];
export const USER_CHIP_URL_PREFIX = '#';
export const DATAGRID_ROW_HEIGHT = 38;
export const DATAGRID_ROW_WIDTH_EXTRA = 12; // the extra width of the row that you subtract to evenly space the columns
export const SNACK_HIDE_DURATION = 3000; // milliseconds
